export default {
  tabs: {
    fiinTradeRankings: 'FiinTrade Rankings',
    allScore: 'All Score',
  },
  tabChildrens: {
    all: 'All',
    hose: 'HOSE',
    hnx: 'HNX',
    rankingIndicators: 'Indicators',
    ranking: 'Rankings',
  },
  popup: {
    warning: {
      title: 'Stock Not Found',
      content:
        'The stock you entered is not ranked in this group. Please try again.',
    },
    ranking: {
      fiinTradeRank: 'FiinTrade Rank',
      value: 'Value',
      growth: 'Growth',
      momentum: 'Momentum',
      vgm: 'VGM',
    },
  },
  footerTextScore:
    'For more details on how to utilize FiinTrade Investment Score, ',
  footerTextRanking:
    'For more details on how to utilize FiinTrade Stock Ranking, ',
  footerClickHere: 'click here',
  titleTableAllScore: 'FiinTrade Investment Score',
  titleTableRanking: 'FiinTrade Stock Rankings',
  fiinTradeRankingsHeader: {
    rtd11: 'Market Cap (Bn.)',
    rankValue: 'Rank',
    ticker: 'Ticker',
    icbName: 'All Industries',
    rankingHistory: 'Ranking History',
    size: 'Size',
    profit: 'Profit',
    cashflow: 'Cashflow',
    valuation: 'Valuation',
    trading: 'Trading',
    analysisCover: 'Analysis Cover',
    allIndustries: 'All Industries',
    ranking: 'Ranking',
    value: 'Value',
    growth: 'Growth',
    momentum: 'Momentum',
    vgm: 'VGM',
  },
  fiinTradeAllScoreHeader: {
    ticker: 'Ticker',
    ranking: 'Ranking',
    icbName: 'All Industries',
    rtd11: 'Market Cap (Bn.)',
    value: 'Value',
    growth: 'Growth',
    momentum: 'Momentum',
    vgm: 'VGM',
  },
};
